// CardCalendario **********************
// ***********calendario.jsx ***********
// data 14/6/24
// autor: W de Paula/ IA
// data: 14/6/24w : 19:02h
// revisões 21/8/24w | 22h01



import { useState } from 'react';
import './calendario.css';

function CardCalendario({ onSelectDate }) {
    const [currentDate, setCurrentDate] = useState(new Date());
    const [selectedDate, setSelectedDate] = useState(new Date());

    const renderDays = () => {
        const date = new Date(currentDate);
        date.setDate(1);

        const days = [];
        while (date.getMonth() === currentDate.getMonth()) {
            days.push(new Date(date));
            date.setDate(date.getDate() + 1);
        }

        const firstDay = days[0].getDay();
        for (let i = 0; i < firstDay; i++) {
            days.unshift(null);
        }

        return days;
    };

    const handlePreviousMonth = () => {
        setCurrentDate(new Date(currentDate.setMonth(currentDate.getMonth() - 1)));
    };

    const handleNextMonth = () => {
        setCurrentDate(new Date(currentDate.setMonth(currentDate.getMonth() + 1)));
    };

    const handleSelectDate = (day) => {
        // console.log('handleSelectDate ');
        if (day && day.getMonth() === currentDate.getMonth()) { // Verifica se o dia pertence ao mês atual
            setSelectedDate(day); // Atualiza o estado para refletir a seleção do usuário
            // console.log(day);
            if (typeof onSelectDate === 'function') {
                onSelectDate(day); // Chama a função passada por propriedade para buscar os horários
            }
        }
    };

    const diasSemana = [
        { id: 'dom', nomeAbreviado: 'D' },
        { id: 'seg', nomeAbreviado: 'S' },
        { id: 'ter', nomeAbreviado: 'T' },
        { id: 'qua', nomeAbreviado: 'Q' },
        { id: 'qui', nomeAbreviado: 'Q' },
        { id: 'sex', nomeAbreviado: 'S' },
        { id: 'sab', nomeAbreviado: 'S' }
    ];

    return (
        <div className="calendar-container">
            <div className="calendar-header">
                <button 
                    className="btn btn-link" 
                    onClick={handlePreviousMonth}
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    title="Mês anterior"
                >
                    <i className="fs-1 bi bi-chevron-left"></i>
                </button>
                <h3>{currentDate.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' })}</h3>
                <button 
                    className="btn btn-link" 
                    onClick={handleNextMonth}
                    data-bs-toggle="tooltip"
                    data-bs-placement="left"
                    title="Próximo mês"
                >
                    <i className="fs-1 bi bi-chevron-right"></i>
                </button>
            </div>

            <div className="calendar-grid">
                {diasSemana.map(day => (
                    <div key={day.id} className="calendar-day-label">{day.nomeAbreviado}</div>
                ))}
                {renderDays().map((day, index) => (
                    <div
                        key={index}
                        className={`calendar-day ${day ? (day.toDateString() === selectedDate.toDateString() ? 'selected' : '') : 'calendar-day-empty'}`}
                        onClick={() => handleSelectDate(day)}
                    >
                        {day && day.getDate()}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default CardCalendario;